export default "__VITE_ASSET__BW1EaUSo__"